export const API_URL = ((import.meta.env.VITE_API_URL as string) ?? '').replace(/\/+$/, '');
export const HUB_URL = (import.meta.env.VITE_HUB_URL as string) ?? '';

export const DISPLAY_URL = (import.meta.env.VITE_DISPLAY_URL as string) ?? '';
export const GOOGLE_FONT_API_KEY = (import.meta.env.VITE_GOOGLE_FONT_API_KEY as string) ?? '';
export const BUCKET_NAME = (import.meta.env.VITE_R2_BUCKET_NAME as string) || (import.meta.env.VITE_BUCKET_NAME as string) || '';
//fonts
export const R2_ENDPOINT = (import.meta.env.VITE_R2_ENDPOINT as string) || '';
export const DEFAULT_UNUSED_FOR_DAYS = 90;


// Backend-driven file archive base
// If you use a dev proxy, you can set this to "/api/file-archive" and ignore API_URL.
//------------------------ NEW FILE ARCHIVE VALUES ------------------- */
export const FILE_ARCHIVE_API_BASE =
  (import.meta.env.VITE_FILE_ARCHIVE_API_BASE as string) ||
  (API_URL ? `${API_URL}/api/FileArchive` : '/api/FileArchive');

// Public URL for the R2 bucket (used to build static URLs for signage display screens)
// Set VITE_R2_PUBLIC_URL in env, falls back to legacy VITE_CLOUDFRONT_URL for backwards compat
export const R2_PUBLIC_URL = (
  (import.meta.env.VITE_R2_PUBLIC_URL as string) ||
  (import.meta.env.VITE_CLOUDFRONT_URL as string) ||
  ''
).replace(/\/+$/, '');
